module.exports = __webpack_public_path__ + "img/cropt.247422c7.jpg";